import {
  RECEIVE_TOPIC_CAT_ITEM,
  RECEIVE_AREA_CAT_ITEM,
  RECEIVE_TOPIC_CAT_BOOK,
  RECEIVE_AREA_CAT_BOOK,
  RECEIVE_ITEM_LIST,
  RECEIVE_INDEX_AREA,
  READING_TYPE,
  RECEIVE_BOOK_ID,
  COUTER,
  RECEIVE_USER_INFO,
  SHOW_LOADING,
  HIDE_LOADING
} from './mutation-type.js'

import {
  reqCategorys,
  reqQuery,
  reqUserInfo
} from '../api/index.js'

export default {
  // 异步获取聚类数据
  async getTopicCategoryItem ({commit}, opt) {
    const result = await reqCategorys(opt)
    if (result) {
      // const data = result.resulter
      const data = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_TOPIC_CAT_ITEM, {data})
    }
  },
  async getAreaCategoryItem ({commit}, opt) {
    const result = await reqCategorys(opt)
    if (result) {
      const data = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_AREA_CAT_ITEM, {data})
    }
  },
  async getTopicCategoryBook ({commit}, opt) {
    const result = await reqCategorys(opt)
    if (result) {
      // const data = result.resulter
      const data = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_TOPIC_CAT_BOOK, {data})
    }
  },
  async getAreaCategoryBook ({commit}, opt) {
    const result = await reqCategorys(opt)
    if (result) {
      const data = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_AREA_CAT_BOOK, {data})
    }
  },
  async getIndexAreaCategory ({commit}, opt) {
    const result = await reqCategorys(opt)
    if (result) {
      const data = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_INDEX_AREA, {data})
    }
  },
  async getItemList ({commit}, opt) {
    commit(SHOW_LOADING)
    const result = await reqQuery(opt)
    commit(HIDE_LOADING)
    if (result) {
      const data = result
      commit(RECEIVE_ITEM_LIST, {data})
    }
  },
  clearLastItemDate ({commit}) {
    const data = {}
    commit(RECEIVE_ITEM_LIST, {data})
  },
  // 存入资源类型标识
  savSourceType ({commit}, itemType) {
    commit(READING_TYPE, {itemType})
  },
  // 存入当前bookId
  saveCurrentBookId ({commit}, bookId) {
    commit(RECEIVE_BOOK_ID, {bookId})
  },
  // 存入标识，代表第几次刷新页面
  saveCounter ({commit}, updataCouter) {
    commit(COUTER, {updataCouter})
  },
  async getUserInfo ({commit}) {
    let userinfo = await reqUserInfo()
    if (userinfo.users.length !== 0) {
      userinfo.users = userinfo.users.filter(item => item.userType !== "0");
    }
    commit(RECEIVE_USER_INFO, userinfo)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js